<template>
  <div :id="thisAvatarId" class="sr-avatar-wrapper">
    <img v-show="!uploadingFile" :id="thisAvatarImgId" :alt="alt" :title="$t(i18n)" :class="getImgClass()" />
    <v-skeleton-loader v-if="uploadingFile" class="sr-avatar-loader" type="avatar" />
    <div v-show="!uploadingFile" :id="thisAvatarTxtId" class="sr-avatar-text">
      <v-icon color="white" small>fa fa-upload</v-icon>
      <div>{{ getTxtMessage() }}</div>
    </div>
    <input :id="thisAvatarInputId" class="sr-avatar-input" type="file" @change="loadFile" />
  </div>
</template>

<script>
import { Types as TypesSnackbar } from "../../../store/modules/snackbar"

const DEFAULT_AVATAR_SRC = "https://cdn.securating.io/public/storage/shared/common/anonymous_avatar1.png"
const DEFAULT_LOGO_SRC = "https://cdn.securating.io/public/storage/shared/common/anonymous_company.png"

export default {
  name: "AvatarField",
  props: {
    dataCy: { required: false },
    withUpload: { required: false, type: Boolean, default: false },
    defaultSrc: { required: false, default: false },
    src: { required: true, default: DEFAULT_AVATAR_SRC },
    alt: { required: false, default: "avatar" },
    user: { required: false, type: Object, default: () => ({}) },
    i18n: { required: true, type: String },
    content: { required: false, default: 'avatar' },
  },
  data: () => ({
    thisAvatarId: "",
    thisAvatarImgId: "",
    thisAvatarTxtId: "",
    thisAvatarInputId: "",
    file: null,
    uploadingFile: false,
    imgDefaultSrc: ""
  }),
  created() {
    this.thisAvatarId = Math.random()
      .toString(36)
      .substr(2, 9)
    this.thisAvatarImgId = this.thisAvatarId + "-img"
    this.thisAvatarTxtId = this.thisAvatarId + "-text"
    this.thisAvatarInputId = this.thisAvatarId + "-input"
    if(this.content === 'logo'){
      this.imgDefaultSrc = DEFAULT_LOGO_SRC
    } else {
      this.imgDefaultSrc = DEFAULT_AVATAR_SRC
    }
    if(!this.src) {
      this.src = this.imgDefaultSrc
    }
    if(this.defaultSrc) {
      this.imgDefaultSrc = this.defaultSrc
    }
  },
  mounted() {
    let image = document.getElementById(this.thisAvatarImgId)
    let text = document.getElementById(this.thisAvatarTxtId)

    image.src = typeof this.src === "string" ? this.src : this.imgDefaultSrc
    image.onerror = this.error
    text.onclick = this.openFileBrowser
  },
  watch: {
    src: function(val) {
      let image = document.getElementById(this.thisAvatarImgId)
      let text = document.getElementById(this.thisAvatarTxtId)

      image.src = typeof val === "string" ? val : this.imgDefaultSrc
      image.onerror = this.error
      text.onclick = this.openFileBrowser
    },
  },
  methods: {
    getImgClass() {
      if(this.content==='logo') {
        return 'sr-avatar-image sr-avatar-content-logo'
      }
      return 'sr-avatar-image sr-avatar-content-avatar'

    },
    getTxtMessage() {
      if(this.content==='logo') {
        return this.$t("common.form.logo.text")
      }
      return this.$t("common.form.avatar.text")
    },
    error() {
      let image = document.getElementById(this.thisAvatarImgId)
      if((image.src !== this.imgDefaultSrc)&&(typeof this.imgDefaultSrc === 'string')){
        image.src = this.imgDefaultSrc
      } else {
        image.src = '';
      }
    },
    setImageSrc(src) {
      let image = document.getElementById(this.thisAvatarImgId)
      image.src = src
    },
    loadFile(e) {
      const files = e.target.files
      if (files.length > 0) {
        this.file = files[0]
        let image = document.getElementById(this.thisAvatarImgId)

        // To display the image instantly to the user we use the URL.createObjectUrl function.
        // This function creates a temporary blob file then we need to revoke the object
        // as soon as possible to avoid memory leaks.
        image.src = URL.createObjectURL(this.file)
        image.onload = () => {
          URL.revokeObjectURL(image.src)
        }

        this.$emit("loaded", this.file)

        if (this.withUpload) {
          this.uploadFile()
        }
      }
    },
    uploadFile() {
      this.uploadingFile = true

      let formData = new FormData()
      formData.append("file_1", this.file)
      if(this.content==="logo") {
        formData.append("virtual_path", "manager/company/logo")
      } else {
        formData.append("virtual_path", "manager/account/avatar")
      }
      this.$axios
        .post("cdn/static/image", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(response => {
          this.$emit("uploaded", response.data.data[0])
        })
        .catch(() => {
          this.$store.dispatch(TypesSnackbar.actions.PUSH_MESSAGE, {
            lines: this.$t("common.form.avatar.errors.upload"),
            config: { timeout: 1000 * 6, color: "error" },
          })
        })
        .finally(() => {
          this.uploadingFile = false
        })
    },
    openFileBrowser() {
      const input = document.getElementById(this.thisAvatarInputId)
      if (input) {
        input.click()
      }
    },
  },
}
</script>
